<template>
    <div>
        <div class="min-w-screen min-h-screen flex items-center justify-center">
            <div class="w-[500px] h-auto bg-white rounded-lg px-[4rem] py-[3rem]">
                <router-link :to="{name: 'role'}" class="cursor-pointer text-indigo-600 mb-4 flex items-center justify-start gap-2">
                    <svg class="w-4 h-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="currentColor"><path d="m313-440 224 224-57 56-320-320 320-320 57 56-224 224h487v80H313Z"/></svg>
                    назад
                </router-link>
                <p class="text-2xl mb-8">Создание компании</p>
                <form @submit.prevent="sendRequestToCreateCompany" class="flex flex-col items-stretch gap-4">
                    <TextInput v-model:textParam="name" labelContent="Наименование" ref="nameInput"/>
                    <TextInput v-model:textParam="officialName" labelContent="Официальное наименование" ref="officialNameInput"/>
                    <div>
                        <label for="main-currency" class="mb-1 block text-sm text-gray-500">Основная валюта</label>
                        <select @change="handleChangeMainCurrency" v-model="mainCurrency" id="main-currency" ref="mainCurrencySelect" class="w-full text-sm text-gray-900 rounded border border-custom-blue focus:ring-blue-500 focus:border-blue-500 flex justify-between items-center py-2 px-4">
                            <option v-for="currency in currencies" :key="currency" :value="currency">{{ currency }}</option>
                        </select>
                    </div>
                    <button type="submit" class="w-full bg-custom-blue hover:bg-custom-blue-hover text-center text-white font-medium rounded-lg text-sm px-5 py-2 mb-8">Создать</button>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';

    import TextInput from '@/components/InputComponents/TextInput.vue';

    export default {
        name: "CreateCompany",
        components: {
            TextInput,
        },
        computed: {
            ...mapState(["currencies"]),
        },
        data() {
            return {
                name: null,
                officialName: null,
                mainCurrency: null,
            }
        },
        methods: {
            handleChangeMainCurrency() {
                const mainCurrencySelect = this.$refs.mainCurrencySelect;
                mainCurrencySelect.setCustomValidity("");
            },
            validateData() {
                if (!this.name) {
                    const nameInput = this.$refs.nameInput.$refs.textInput;
                    nameInput.setCustomValidity("Введите наименование компании");
                    nameInput.reportValidity();
                    return false;
                }
                if (!this.officialName) {
                    const officialNameInput = this.$refs.officialNameInput.$refs.textInput;
                    officialNameInput.setCustomValidity("Введите официальное наименование компании");
                    officialNameInput.reportValidity();
                    return false;
                }
                
                if (!this.mainCurrency) {
                    const mainCurrencySelect = this.$refs.mainCurrencySelect;
                    mainCurrencySelect.setCustomValidity("Выберите основную валюту компании");
                    mainCurrencySelect.reportValidity();
                    return false;
                }
                return true
            },
            async sendRequestToCreateCompany() {
                if (!this.validateData()) {
                    return;
                }

                const data = {
                    name: this.name,
                    official_name: this.officialName,
                    main_currency: this.mainCurrency,
                }
                const result = await this.$store.dispatch("createCompany", data);
                if (result.successfully) {
                    this.$store.dispatch("updateCurrentSchedulePeriod", {date: this.$globalMethods.getFirstDayOfCurrentMonth(), verbose: this.$globalMethods.getCurrentMonthAndYear()});
                    this.$router.push({name: "dashboard"});
                }
            }
        }
    }
</script>